import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78fedfc7")

_pushScopeId("data-v-78fedfc7")
const _hoisted_1 = { class: "trade-trend df-middle c-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Market Sentiment")
const _hoisted_3 = { class: "bar flex-1 ml-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_t, {
      path: "symbol_2",
      class: "f-sm"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "positive",
        style: {width: `${_ctx.trend.up}%`}
      }, null, 4)
    ])
  ]))
})